import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

export async function fetchSettings() {
  const response = await apiFetch(`${API_BASE}/settings`, {
    headers: authHeaders(),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudieron cargar las tarifas'));
  }
  return payload || {};
}

export async function updateSettings(body) {
  const response = await apiFetch(`${API_BASE}/settings`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, 'No se pudieron guardar las tarifas'));
  }
  return payload || {};
}
